export default "__VITE_ASSET__25047cae__"